import background from './images/background_multitec_pattern_01.png'
import multitecLoja from './images/foto-loja.png'
import logo2 from './images/logo (2).png'
import logo from './images/logo.png'
import multitecLogo from './images/multitec-logo.png'

export default {
  multitecLogo,
  multitecLoja,
  background,
  logo,
  logo2,
}
